import z from 'zod';

export enum StudyStatus {
  GENERATED = 'GENERATED',
  REVIEWED = 'REVIEWED',
  FLAGGED = 'FLAGGED',
}

export const studyStatusSchema = z.enum(StudyStatus);
